import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var PayoutCalculationIA = function PayoutCalculationIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GoibG8",
    defaultMessage: [{
      "type": 0,
      "value": "Les paiements pour les marques sur Faire sont calculés selon la formule suivante : montant du paiement = (sous-total de la commande) + (remboursement de l'expédition) - (commission) - (frais de traitement des paiements)"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "UVFpLi",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Sous-total de la commande"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : total des prix revendeur des articles de votre commande, après déduction des promotions financées par la marque."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EZKlAY",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Remboursement des frais d'expédition"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : coût de l'expédition (ne s'applique que lorsque vous expédiez la commande par vous-même, et non en utilisant Expédier avec Faire)."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "AWOZxu",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Commission"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : le sous-total de la commande multiplié par le taux de commission pour cette commande"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zNePjD",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Frais de traitement des paiements"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " : le sous-total des articles multiplié par les frais de traitement des paiements"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "H3tdjk",
    defaultMessage: [{
      "type": 0,
      "value": "Vous trouverez le calcul complet de votre paiement dans votre onglet "
    }, {
      "children": [{
        "type": 0,
        "value": "Commandes"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ", en cliquant sur la page des détails de la commande. Faites défiler l'écran jusqu'à la section "
    }, {
      "children": [{
        "type": 0,
        "value": "« Vous avez reçu un paiement ! »et "
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " sélectionnez "
    }, {
      "children": [{
        "type": 0,
        "value": "Afficher le récapitulatif du paiement"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". Vous y trouverez une ventilation détaillée du paiement."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};